export const COLLARS_EXPORT_HEADS = [
  { id: "id", label: "ID" },
  { id: "number", label: "Número" },
  { id: "responsibleTeam", label: "Equipe Responsável" },
  { id: "lastEditor", label: "Último Editor" },
  { id: "lastLocationLatitude", label: "Última Latitude" },
  { id: "lastLocationLongitude", label: "Última Longitude" },
  { id: "individualId", label: "Indivíduo ID" },
  { id: "createdAt", label: "Criado em" },
  { id: "updatedAt", label: "Atualizado em" },
];

export const CAMERA_TRAPS_EXPORT_HEADS = [
  { id: "id", label: "ID" },
  { id: "number", label: "Número" },
  { id: "responsibleTeam", label: "Equipe Responsável" },
  { id: "lastEditor", label: "Último Editor" },
  { id: "latitude", label: "Latitude" },
  { id: "longitude", label: "Longitude" },
  { id: "attachmentsCount", label: "Quantidade de Anexos" },
  { id: "createdAt", label: "Criado em" },
  { id: "updatedAt", label: "Atualizado em" },
];
